const React = require('react');
const PropTypes = require('prop-types');
const NoImage = require('./svgs-v2/icons/no-image.svg').default;

class ErrorBoundary extends React.Component {
  state = {
    hasErrored: false,
  };

  componentDidCatch(error, info) {
    console.error(error, info, this.props);

    this.setState({
      hasErrored: true,
    });
  }

  render() {
    if (this.state.hasErrored) {
      return <NoImage {...this.props.svgProps} />;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  svgProps: PropTypes.shape({
    className: PropTypes.string,
    viewBox: PropTypes.string,
  }).isRequired,
};

module.exports = ErrorBoundary;
